import ModuleSmartStream from '@vivotek/ssmux';
import { getTagged } from '@vivotek/lib-utility/logger';

const Log = getTagged('ThreadingCanvas/cassiae');
/*
 * Copyright (c) 2018 Vivotek Inc. All rights reserved.
 *
 * +-----------------------------------------------------------------+
 * | THIS SOFTWARE IS FURNISHED UNDER A LICENSE AND MAY ONLY BE USED |
 * | AND COPIED IN ACCORDANCE WITH THE TERMS AND CONDITIONS OF SUCH  |
 * | A LICENSE AND WITH THE INCLUSION OF THE THIS COPY RIGHT NOTICE. |
 * | THIS SOFTWARE OR ANY OTHER COPIES OF THIS SOFTWARE MAY NOT BE   |
 * | PROVIDED OR OTHERWISE MADE AVAILABLE TO ANY OTHER PERSON. THE   |
 * | OWNERSHIP AND TITLE OF THIS SOFTWARE IS NOT TRANSFERRED.        |
 * |                                                                 |
 * | THE INFORMATION IN THIS SOFTWARE IS SUBJECT TO CHANGE WITHOUT   |
 * | ANY PRIOR NOTICE AND SHOULD NOT BE CONSTRUED AS A COMMITMENT BY |
 * | VIVOTEK INC.                                                    |
 * +-----------------------------------------------------------------+
 *
 */

export default class Cassiae {
  constructor(params /* mounttype */, done = () => {}, ssmuxInstance) {
    this.context = null;
    this.texture = 0;
    this.m_heatmap = 0;
    // this.decodedFrameCnt = 0;

    this.focusView = 0;
    this.opt = {};

    // present mode : 0(1O), 1(1R), 2(1P)
    this.opt.pm = 1;

    // mount type: 0(wall), 1(ceiling), 2(floor)
    this.opt.mt = 1;

    // input image source
    this.opt.src = {
      w: 0, h: 0, cx: 0, cy: 0, r: 1
    };

    // output render roi
    this.opt.roi = {
      x: 0,
      y: 0,
      w: 0, // canvas width
      h: 0, // canvas height
    };

    if (!ssmuxInstance) {
      new ModuleSmartStream().then((ssmux) => {
        this.module = ssmux;
        done && done(this);
      });
    } else {
      this.module = ssmuxInstance;
      Promise.resolve().then(() => {
        Log.log('ssmux done');
        done(this);
      });
    }
  }

  // ---------------------------------------------------------------------------------
  // handle input image source
  initTexture(sFilename) {
    this.texture = this.context.createTexture();
    this.context.bindTexture(this.context.TEXTURE_2D, this.texture);
    this.context.texImage2D(this.context.TEXTURE_2D, 0, this.context.RGBA, 1, 1, 0, this.context.RGBA,
      this.context.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 255]));
    this.context.bindTexture(this.context.TEXTURE_2D, null);
  }

  initHeatmapTexture(sFilename) {
    this.m_heatmap = this.context.createTexture();
    this.context.bindTexture(this.context.TEXTURE_2D, this.m_heatmap);
    this.context.texImage2D(this.context.TEXTURE_2D, 0, this.context.RGBA, 1, 1, 0,
      this.context.RGBA, this.context.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 0]));
    this.context.bindTexture(this.context.TEXTURE_2D, null);
  }

  isPowerOfTwo(x) {
    // eslint-disable-next-line no-bitwise
    return (x & (x - 1)) === 0;
  }

  handleLoadedTexture(texture) {
    try {
      this.context.bindTexture(this.context.TEXTURE_2D, texture);

      this.context.texImage2D(this.context.TEXTURE_2D, 0, this.context.RGBA, this.context.RGBA, this.context.UNSIGNED_BYTE, texture.image);

      this.context.texParameteri(this.context.TEXTURE_2D, this.context.TEXTURE_WRAP_S, this.context.CLAMP_TO_EDGE);
      this.context.texParameteri(this.context.TEXTURE_2D, this.context.TEXTURE_WRAP_T, this.context.CLAMP_TO_EDGE);

      if (this.isPowerOfTwo(texture.image.width) && this.isPowerOfTwo(texture.image.height)) {
        this.context.texParameteri(this.context.TEXTURE_2D, this.context.TEXTURE_MAG_FILTER, this.context.NEAREST);
        this.context.texParameteri(this.context.TEXTURE_2D, this.context.TEXTURE_MIN_FILTER, this.context.NEAREST);
      } else {
        this.context.texParameteri(this.context.TEXTURE_2D, this.context.TEXTURE_MAG_FILTER, this.context.LINEAR);
        this.context.texParameteri(this.context.TEXTURE_2D, this.context.TEXTURE_MIN_FILTER, this.context.LINEAR);
      }

      this.context.bindTexture(this.context.TEXTURE_2D, null);
    } catch (e) {
      console.log('handleLoadedTexture error: ', e.message);
    }
  }

  // eslint-disable-next-line no-unused-vars
  setTextureImg(sFilename) {
    this.texture.image = sFilename;
    this.handleLoadedTexture(this.texture);
  }

  setHeatmapImg(sFilename) {
    this.m_heatmap.image = sFilename;
    this.handleLoadedTexture(this.m_heatmap);
  }

  isTextureUpdated(video) {
    /* var bUpdateTexture = false;
    if (video.webkitDecodedFrameCount !== undefined) {
      // webkitDecodedFrameCount - number of frames that have been demuxed and extracted out of the media.
      if (this.decodedFrameCnt !== video.webkitDecodedFrameCount) {
        bUpdateTexture = true;
        this.decodedFrameCnt = video.webkitDecodedFrameCount;
      }
    }
    else if (video.mozDecodedFrames !== undefined) {
      // mozDecodedFrames - number of frames that have been decoded
      if (this.decodedFrameCnt !== video.mozDecodedFrames) {
        bUpdateTexture = true;
        this.decodedFrameCnt = video.mozDecodedFrames;
      }
    }
    else {
      bUpdateTexture = true;
    }
    return bUpdateTexture; */
    return true;
  }

  setGL(gl, canvas) {
    this.context = gl;

    this.module.canvas = canvas;
    this.module.cassiae_initial(gl.viewportWidth, gl.viewportHeight);
    this.module.cassiae_setPresentMode(this.opt.pm);
    this.module.cassiae_setMountType(this.opt.mt);

    // Warning: Don't use internal texture anymore. Users must set an input texture when rendering.
    this.initTexture(this);
    this.initHeatmapTexture(this);
  }

  release(gl, canvas) {
    this.module.cassiae_release();

    this.context.deleteTexture(this.texture);
    this.context.deleteTexture(this.m_heatmap);
  }

  setMountType(mt) {
    this.opt.mt = mt;
    this.module.cassiae_setMountType(mt);
  }

  setPresentMode = (present) => {
    this.opt.pm = present;
    this.module.cassiae_setPresentMode(present);
  };

  setModelName = (name) => {
    this.module.cassiae_setModelName(name);
  };

  enable1OVerification = (enable) => {
    this.module.cassiae_setValid1O(enable);
  };

  isValid() {
    return this.module.cassiae_isValid();
  }

  // Set fisheye source valid roi (NOTE: consider radius and center)
  setCenterRadius(cx, cy, r, guess) {
    if (cx !== this.opt.src.cx || cy !== this.opt.src.cy || r !== this.opt.src.r) {
      if (!guess) {
        Log.log('set source', cx, cy, r);
      } else {
        Log.log('set source', cx, cy, r, ' from guessing');
      }
      this.opt.src.cx = cx;
      this.opt.src.cy = cy;
      this.opt.src.r = r;
      this.module.cassiae_setCenterRadius(cx, cy, r);
    }
  }

  setResolution(w, h) {
    if (w !== this.opt.src.w || h !== this.opt.src.h) {
      /**
       * For some reason if resolution(cassiae_setTextureSize) is changed
       * before new center radius is set(cassiae_setCenterRadius),
       * the result of dewarp would be incorrect.
       * However in our case the video size change is always
       * happening before the packet infomation tell us the x,y,r
       * changes. So here we use normalization to guess the new x,y,r;
       * since this.setCenterRadius is protecting repeated call by
       * comparing the value it will not be called twice even
       * we get correct x, y, r later.
       */
      if (this.isCenterRadiusNotUpdated(w)) {
        if (this.opt.src.cx && this.opt.src.w) {
          this.setCenterRadius(
            Math.round(this.opt.src.cx * (w/this.opt.src.w)),
            Math.round(this.opt.src.cy * (h/this.opt.src.h)),
            Math.round(this.opt.src.r * (w/this.opt.src.w)),
            true,
          );
        } else {
          this.setCenterRadius(
            Math.round(w / 2),
            Math.round(h / 2),
            Math.round(w / 2 * 0.987),
            true,
          );
        }
      }
      this.opt.src.w = w;
      this.opt.src.h = h;
      this.module.cassiae_setTextureSize(w, h);
    }
  }

  isCenterRadiusNotUpdated(width) {
    const x = Math.abs(this.opt.src.cx * 2 - width) / width;
    /**
     * If center x * 2 is too much different with given width, treat it as center radius not updated.
     */
    return x > 0.1;
  }

  // Set render output roi (NOTE: must set this option before rendering.)
  setROI(x, y, w, h) {
    if (x !== this.opt.roi.x || y !== this.opt.roi.y || w !== this.opt.roi.w || h !== this.opt.roi.h) {
      this.opt.roi = {
        x, y, w, h
      };
      this.module.cassiae_setDisplaySize(w, h);
    }
  }

  getViewID(x, y, w, h) {
    return this.module.cassiae_getViewID(x, y, w, h);
  }

  // (for PTZ control) Set pan, tilt, zoom.
  // bFlag-> true: absolute position, false: relative position
  setPTZ(bFlag, pan, tilt, zoom) {
    this.module.cassiae_setPTZ(this.focusView, bFlag, pan, tilt, zoom);
  }

  // (for PTZ control) Get current pan, tilt, zoom.
  getPTZ() {
    return this.module.cassiae_getPTZ(this.focusView);
  }

  // (for PTZ control : O control R) Set pan, tilt by 1O point.
  // point(x, y) : range 0 ~ 1
  setPanTiltByPointO(x, y) {
    const xi = x * this.opt.src.w;
    const yi = y * this.opt.src.h;

    const newPT = this.module.cassiae_getPTFromO(this.focusView, xi, yi);
    const oldPTZ = this.getPTZ();

    this.setPTZ(true, newPT.pan, newPT.tilt, oldPTZ.zoom);
  }

  setPresetInfo(presetInfo) {
    this.module.cassiae_setPresetInfo(presetInfo);
  }

  getPresetInfo() {
    return this.module.cassiae_getPresetInfo();
  }

  setMouseDown(event) {
    this.focusView = this.getViewID(event.offsetX, event.offsetY, this.opt.roi.w, this.opt.roi.h);
    this.module.cassiae_setMouseDown(this.focusView, event.offsetX, event.offsetY);
  }

  setMouseUp(event) {
    this.module.cassiae_setMouseUp(this.focusView, event.offsetX, event.offsetY);
  }

  setMouseMove(event) {
    this.module.cassiae_setMouseMove(this.focusView, event.offsetX, event.offsetY);
  }

  resetPTZ() {
    this.module.cassiae_resetPTZ();
  }

  addLine(x0, y0, x1, y1) {
    this.module.cassiae_line_add(x0, y0, x1, y1);
  }

  clearLines() {
    this.module.cassiae_line_clear();
  }

  // (OR mapping) Get a point on 1O image from a point on dewarped image
  // point(x, y) : range 0 ~ 1
  get1OPointFromOutXY(x, y) {
    const xi = x * this.opt.roi.w;
    const yi = y * this.opt.roi.h;

    const pt = this.module.cassiae_get1OPointFromOutXY(this.focusView, xi, yi);

    pt.x /= this.opt.src.w;
    pt.y /= this.opt.src.h;

    return pt;
  }

  // (OR mapping) Get 1R dewarp region (40 points) on 1O
  // point(x, y) : range 0 ~ 1
  getDewarpRegion() {
    const region = [];
    const pointCnt = 10;
    for (let i = 0; i < pointCnt; i += 1) {
      const point = this.get1OPointFromOutXY((i / pointCnt), 0);
      region.push(point);
    }
    for (let i = 0; i < pointCnt; i += 1) {
      const point = this.get1OPointFromOutXY(1, (i / pointCnt));
      region.push(point);
    }
    for (let i = 0; i < pointCnt; i += 1) {
      const point = this.get1OPointFromOutXY((1 - i / pointCnt), 1);
      region.push(point);
    }
    for (let i = 0; i < pointCnt; i += 1) {
      const point = this.get1OPointFromOutXY(0, (1 - i / pointCnt));
      region.push(point);
    }
    return region;
  }

  render(source) {
    this.renderVideo(source);
  }

  // Render
  renderVideo(video) {
    if (video === undefined) {
      return;
    }

    let width = 0;
    let height = 0;
    if (video.tagName === 'IMG') {
      width = video.naturalWidth;
      height = video.naturalHeight;
    } else if (video.tagName === 'CANVAS' || video.width) {
      width = video.width;
      height = video.height;
    } else {
      width = video.videoWidth;
      height = video.videoHeight;
    }

    if (width === 0 || height === 0) {
      return;
    }

    if (this.isTextureUpdated(video)) {
      this.setTextureImg(video, video);
    }

    this.setResolution(width, height);

    this.context.activeTexture(this.context.TEXTURE0);
    this.context.bindTexture(this.context.TEXTURE_2D, this.texture);

    this.module.cassiae_render();

    this.context.activeTexture(this.context.TEXTURE0);
    this.context.bindTexture(this.context.TEXTURE_2D, null);
  }

  // Render
  renderVideoAndCover(video, cover) {
    if (video === undefined || cover === undefined) {
      return;
    }

    let width = 0;
    let height = 0;
    if (video.tagName === 'IMG') {
      width = video.naturalWidth;
      height = video.naturalHeight;
    } else if (video.tagName === 'CANVAS') {
      width = video.width;
      height = video.height;
    } else {
      width = video.videoWidth;
      height = video.videoHeight;
    }

    if (width === 0 || height === 0) {
      return;
    }

    if (this.isTextureUpdated(video)) {
      this.setTextureImg(video, video);
      this.setHeatmapImg(cover);
    }

    this.setResolution(width, height);

    this.context.activeTexture(this.context.TEXTURE0);
    this.context.bindTexture(this.context.TEXTURE_2D, this.texture);
    this.context.activeTexture(this.context.TEXTURE1);
    this.context.bindTexture(this.context.TEXTURE_2D, this.m_heatmap);

    this.module.cassiae_renderWithHeatmap();

    this.context.activeTexture(this.context.TEXTURE0);
    this.context.bindTexture(this.context.TEXTURE_2D, null);
    this.context.activeTexture(this.context.TEXTURE1);
    this.context.bindTexture(this.context.TEXTURE_2D, null);
  }
}
